

import { Box } from "@material-ui/core"
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { navigate } from '@reach/router'
import AmsLoading from "../../atoms/AmsLoading/AmsLoading";
import AmsDivider from "../../atoms/AmsDivider/AmsDivider";
import AmsTypography from "../../atoms/AmsTypography/AmsTypography";
import MessageBlock from "../../molecules/MessageBlock/MessageBlock";
import AmsButton from "../../atoms/AmsButton/AmsButton";
import AmsRoomsList from "../../molecules/AmsRoomsList/AmsRoomsList";
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from "../../context";
import axios from "axios";
import actionTypeConstants from "../../utils/actionTypeConstants";
import { getMobileOperatingSystem } from "../../utils/helpers";
//import cubesheetData from "../../utils/cubeSheetList";
const inventoryApiEndPoint = process.env["REACT_APP_INVENTORY_API_END_POINT"]

const inventorey_api_key = process.env["REACT_APP_INVENTORY_API_KEY"];

const customerDetailsApiEndPoint = process.env["REACT_APP_CUSTOMER_DETAIL_END_POINT"];

const api_key = process.env["REACT_APP_API_KEY"];

interface Room {
    [key: string]: Array<{
        item: string;
        quantity: number;
        text: string;
        index: number;
        itemId: string;
        cubes: number;
    }>;
}

const useStyles = makeStyles({
    buttonContainer: {
        // padding: "4vw",
        // width: "92vw",
        background: "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%)",
        marginBottom: (props: any) => props?.os === "iOS" ? "0px" : "0px",
        display: 'flex',
        alignItems: 'flex-end',
    },
});


const AmsRooms = (props: any) => {
    const { templateProps } = props
    const { title, messageBlock, roomItems, btnProps } = templateProps
    const [loading, setLoading] = useState(true);
    const [inventoryList, setInventoryList] = useState([]);
    const [selectedRooms, setSelectedRooms] = useState([]);
    const [notSelectedRoom, setNotSelectedRoom] = useState([])
    const urlParams = new URLSearchParams(window?.location?.search);
    let custToken = urlParams.get("custToken");

    //let additionalItems = JSON.parse(cubesheetData);

    let os: any = getMobileOperatingSystem();

    const classes = useStyles({ os: os });


    const dispatch: any = useContextSelector(
        StoreContext,
        (store) => store?.dispatch
    );

    useEffect(() => {
        sessionStorage.clear()
        if (custToken) {
            sessionStorage.setItem('custToken', custToken?.toString());
            
            getCustomerDetails();
        }


    }, [])

    const getCustomerDetails = async () => {
        let data = {
            secureToken: custToken,
        };
        let response = await axios.post(`${customerDetailsApiEndPoint}`, data, {
            headers: {
                "x-api-key": api_key,
            },
        });

        if (response) {
            let customerDetails = response?.data;

            let customerId = customerDetails[0]?.CustomerID
            sessionStorage.setItem('CID', customerDetails[0]['CustomerID'])
            getInventory(customerId);
            dispatch({
                type: actionTypeConstants.CUSTOMER_JOURNEY,
                payload: {
                    customerDetails: customerDetails[0],
                },
            });
        }
    };

    const customerContext: any = useContextSelector(
        StoreContext,
        (store) => store?.appState?.customerJourneyContext
    )

    useEffect(() => {
        let roomInfo: any = sessionStorage.getItem(`roomInfo`)
        if (roomInfo) {
            roomInfo = JSON.parse(roomInfo);

            //choosing rooms without other room
            //let newRoomInfo = roomInfo.filter((room:any) => Object.keys(room)[0] !== "Other Room");

            const roomArray = roomInfo.map((room: any, index: any) => {

                const roomName = Object.keys(room)[0];
                const roomIndex = room[roomName][0].index;
                return {
                    room: roomName,
                    index: roomIndex,
                    text: roomName
                };

            });



            let selectedRoom: any = getSelectedRoom(roomInfo);

            if(selectedRoom.length > 0){
                sessionStorage.setItem("inventoryButton", "true")
            }else{
                sessionStorage.setItem("inventoryButton", "false")
            }

            // Filter rooms that are present in the selected array
            const isPresent = roomArray.filter((room: any) => selectedRoom.includes(room.room));

            // Filter rooms that are absent in the selected array
            const isAbsent = roomArray.filter((room: any) => !selectedRoom.includes(room.room));

            setNotSelectedRoom(isAbsent);
            setSelectedRooms(isPresent)
            setLoading(false)

        } else {

            if (!custToken) {
                let customerId = customerContext?.customerDetails?.CustomerID;
                getInventory(customerId)
            }

        }


    }, [])

    function getSelectedRoom(data: Room[]): Room[] {
        let selectedData: any = data.filter(room =>
            Object.values(room)[0].some((item: any) => (item.quantity > 0))
        );

        selectedData = selectedData.flatMap((room: any) => Object.keys(room));

        return selectedData
    }


    const getInventory = async (customerId: any) => {
        let data = {
            "customerId": customerId,
            //"customerId":7057814,
        }
        let response = await axios.post(`${inventoryApiEndPoint}`, data, {
            headers: {
                'x-api-key': inventorey_api_key,

            }
        })
        let inventory = response?.data

        //Getting all the room name
        const uniqueRoomsArray = inventory.reduce((accumulator: any, current: any) => {
            const existingRoom = accumulator.find((item: any) => item.room === current.room);

            if (!existingRoom) {
                accumulator.push({
                    room: current.room,
                    index: accumulator.length + 1, // Adding a unique index
                    text: current.room,
                    cubes: current.cubes,
                    itemId: current.itemId
                });
            }

            return accumulator;
        }, []);

        //this is to arrage all the inventroy of a particular room under that room
        const roomObject = inventory.reduce((accumulator: any, current: any, index: any) => {
            const { item, quantity, room, cubes, itemId } = current;

            if (!accumulator[room]) {
                accumulator[room] = [];
            }

            accumulator[room].push({
                item,
                quantity,
                text: item,
                index: index + 1, // Adding 1 to make the index start from 1
                cubes: cubes,
                itemId: itemId,
                room:room
            });

            return accumulator;
        }, {});

        const roomInfo = Object.keys(roomObject).map((room) => ({
            [room]: roomObject[room],
        }));


        let selectedRoom: any = getSelectedRoom(roomInfo);

        if(selectedRoom.length > 0){
            sessionStorage.setItem("inventoryButton", "true")
        }else{
            sessionStorage.setItem("inventoryButton", "false")
        }
        selectedRoom = uniqueRoomsArray.filter((room: any) => (selectedRoom.includes(room?.room)));

        const remainingRooms = uniqueRoomsArray.filter((room: any) => (!selectedRoom.includes(room?.room)));

        setNotSelectedRoom(remainingRooms);
        setSelectedRooms(selectedRoom)


        sessionStorage.setItem('roomInfo', JSON.stringify(roomInfo))
        sessionStorage.setItem('inventory', JSON.stringify(inventory))
        setLoading(false)

    }



    const handleSubmit = async (event: any) => {

        let firstRoom = customerContext?.rooms[0]['room']
        firstRoom = firstRoom.replace(/\s/g, "-");

        if (custToken) {
            dispatch({
                type: actionTypeConstants.CUSTOMER_JOURNEY,
                payload: {
                    "isAffirm": true,
                },
            })
        }

        navigate(`${btnProps?.nextScreen}?room=${firstRoom}`)
    }


    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                p={4}
                mt={18}
            >
                {<AmsLoading />}
            </Box>
        )
    }

    return (
        <Box className="baseContainerBlock HomeBlock" >
            <Box className="mainContainer">
                <Box style={{ marginBottom: '100px' }}>
                    <Box className="title" mb={5}>
                        <AmsTypography variant="h1" text={title} />
                    </Box>
                    <Box mb={5} mt={5}>
                        <AmsDivider />
                    </Box>

                    <Box mb={5} mt={5} className="roomsList">
                        {roomItems?.length > 0 && <AmsRoomsList rooms={notSelectedRoom} roomPresent={selectedRooms} />}
                    </Box>

                    <Box mb={5} mt={5} className="messageBlock">
                        {messageBlock && <MessageBlock message={messageBlock?.text} />}
                    </Box>
                </Box>
            </Box>
            <Box className="buttonContainerBlock">
                <Box className={classes.buttonContainer}>
                    <AmsButton
                        attributes={btnProps?.attributes}
                        handleClick={handleSubmit}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default AmsRooms